<template>
  <div>
    <button v-if="paginationStyle == 'append'" v-show="totalCount > perPage && currentPage != totalPages" class="lm" @click="$emit('load:more')">
      <translate>Load More</translate>
    </button>

    <ul class="catalog-pagination" v-if="paginationStyle == 'paginate' && totalCount > perPage">
      <!-- Left Arrow-->
      <li>
        <button @click="$emit('goto:page', currentPage - 1)" :disabled="currentPage == 1" aria-label="previous-page">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
        </button>
      </li>
      <!-- Page counts on mobile-->
      <li class="mobile">
        <button disabled>
          {{ currentPage }}/{{ totalPages }}
        </button>
      </li>
      <!-- Page list on desktop-->
      <li class="desk" v-for="p in pagination" :key="p">
        <button :disabled="p == null" :class="{ active: p == currentPage }" @click="$emit('goto:page', p)">
          {{ p == null ? '...' : p }}
        </button>
      </li>
      <!-- Right Arrow-->
      <li>
        <button @click="$emit('goto:page', currentPage + 1)" :disabled="currentPage == totalPages"
          aria-label="next-page">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        </button>
      </li>
    </ul>
  </div>

</template>

<script>
export default {
  name: "cms-paginaiton",
  props: {
    paginationStyle: {
      type: String,
      default: "paginate"
    },
    totalCount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: String,
      default: "45",
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.perPage)
    },
    pagination() {
      const currentPage = this.currentPage
      if (this.totalPages <= 7) {
        return Array.from({ length: this.totalPages }, (_, i) => i + 1)
      }
      if (currentPage < 5) {
        return [1, 2, 3, 4, 5, null, this.totalPages]
      }
      if (currentPage == this.totalPages) {
        return [1, null, currentPage - 4, currentPage - 3, currentPage - 2, currentPage - 1, currentPage]
      }
      if (currentPage == (this.totalPages - 3)) {
        return [1, null, currentPage - 1, currentPage, currentPage + 1, currentPage + 2, currentPage + 3]
      }
      if (currentPage == (this.totalPages - 2)) {
        return [1, null, currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2]
      }
      if (currentPage == (this.totalPages - 1)) {
        return [1, null, currentPage - 3, currentPage - 2, currentPage - 1, currentPage, currentPage + 1]
      }
      if (currentPage >= 5) {
        return [1, null, currentPage - 1, currentPage, currentPage + 1, null, this.totalPages]
      }
    },
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  display: flex;
  justify-content: center;
  margin: 2rem auto 1rem auto;
  width: max-content;
  box-shadow: var(--crf-shadow);
  border-radius: 5px;
  overflow: hidden;
  padding: 0;
}

ul li button {
  font-size: 0.86rem;
  color: var(--crf-flip);
  background: var(--crf-bg-high);
  outline: none;
  border-top: 1px solid var(--crf-border);
  border-bottom: 1px solid var(--crf-border);
  padding: 8px 15px;
  outline: none;
  border: none;
  cursor: pointer;
}

ul li button:hover:not([disabled]):not(.active) {
  background-color: var(--crf-bg-mute);
}

ul li.desk {
  display: none;
}

ul li button.active {
  color: #fff;
  background-color: var(--crf-accent);
}

ul li button[disabled] {
  cursor: not-allowed;
}

ul li:first-child svg,
ul li:last-child svg {
  width: 12px;
  color: var(--crf-flip);
}

button.lm {
  font-size: 0.8rem;
  color: var(--crf-invert);
  background: var(--crf-accent);
  box-shadow: var(--crf-shadow);
  border-radius: 4px;
  border: 1px solid var(--crf-border);
  outline: none;
  padding: 8px 10px;
  border-radius: 6px;
  display: block;
  margin: 1rem auto;
  outline: none;
  border: none;
}

@media screen and (min-width: 768px) {
  ul li.desk {
    display: inline-block;
  }

  ul li.mobile {
    display: none;
  }
}
</style>
